import { render, staticRenderFns } from "./OurBuisiness2.vue?vue&type=template&id=938c341a&scoped=true"
import script from "./OurBuisiness2.vue?vue&type=script&lang=js"
export * from "./OurBuisiness2.vue?vue&type=script&lang=js"
import style0 from "./OurBuisiness2.vue?vue&type=style&index=0&id=938c341a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938c341a",
  null
  
)

export default component.exports